"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Button_1 = __importDefault(require("@/components/Button"));
const fa_1 = require("react-icons/fa");
const style_1 = require("./style");
function TitleSection({ title, addRowButtonLabel, onAddRow, }) {
    return (react_1.default.createElement(style_1.StyledTitleSection, null,
        react_1.default.createElement(style_1.TableTitle, { variant: "h1" },
            react_1.default.createElement("strong", null, title)),
        addRowButtonLabel && onAddRow && (react_1.default.createElement(style_1.ButtonWrapper, null,
            react_1.default.createElement(Button_1.default, { color: "primary", variant: "contained", label: addRowButtonLabel, leftLabel: fa_1.FaPlus, leftLabelSize: 14, onClick: onAddRow })))));
}
exports.default = TitleSection;
